import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css'; 

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Wallabies Warm Care</title>
        <meta
          name="description"
          content="Wallabies Warm Care respects your privacy. Learn about how we collect, use, and protect your personal data when using our forced air-warming systems and products."
        />
      </Helmet>

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Privacy Policy</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy</h3>

              <p>
                At Wallabies Warm Care, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and protect your data when you use our services and products, including forced air-warming systems and blankets.
              </p>

              <div className="section">
                <p className="highlight ">Information We Collect:</p>
                <p className="highlight ">1. Personal Information:</p>
                <p>
                  We collect personal details such as your name, contact information (phone number, email address), payment details, and shipping address to facilitate your orders and provide our products.
                </p>

                <p className="highlight ">2. Usage Data:</p>
                <p>
                  We may collect browsing data like IP address, device information, and usage patterns on our website to improve user experience and optimize our services.
                </p>

                <p className="highlight ">3. Location Data:</p>
                <p>
                  With your consent, we may collect location data to enhance our product and service delivery, particularly in cases where our systems may require geographical context for use or customization.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">How We Use Your Information:</p>
                <p className="highlight ">1. Service Delivery:</p>
                <p>
                  Your personal details are used to process orders, provide confirmation, and ensure timely delivery of products such as our forced air-warming systems and blankets.
                </p>

                <p className="highlight ">2. Product Improvement:</p>
                <p>
                  The data we collect helps us improve our website, services, and products, ensuring a better user experience and higher quality in our offerings.
                </p>

                <p className="highlight ">3. Communication:</p>
                <p>
                  We use your contact information to send updates on your orders, product information, and other relevant communications via email, SMS, or phone.
                </p>

                <p className="highlight ">4. Marketing & Promotions:</p>
                <p>
                  With your consent, we may send special offers, discounts, or promotions regarding our forced air-warming systems or related products. You can opt out of these communications at any time.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">Information Sharing:</p>
                <p className="highlight ">1. Trusted Third-Party Providers:</p>
                <p>
                  We may share your data with trusted third-party providers who assist with payment processing, shipping, or customer service. These providers are obligated to safeguard your data and only use it for the intended purposes.
                </p>

                <p className="highlight ">2. Legal Compliance:</p>
                <p>
                  We may disclose your information to comply with legal obligations or to protect our rights, property, and safety, or that of our customers and users.
                </p>
              </div>

              <div className="section">
                <p className="highlight ">Data Security:</p>
                <p>
                  We implement technical, administrative, and physical security measures to protect your personal information. However, please note that no method of transmission over the internet or method of electronic storage is 100% secure.
                </p>

                <p className="highlight ">Your Rights:</p>
                <p>
                  You have the right to request access to, correction of, or deletion of your personal data. You may also choose to opt-out of marketing communications at any time. To exercise these rights, please contact our support team.
                </p>

                <p className="highlight ">Policy Updates:</p>
                <p>
                  We may update this Privacy Policy from time to time. When we make changes, we will post the updated version on our website and update the date at the top of the policy. We encourage you to review this policy periodically to stay informed on how we protect your data.
                </p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or concerns regarding this Privacy Policy, please reach out to us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+918956322311">+91 8956322311</a></li>
              <li><b>Email:</b> <a href="mailto:info@wallabieswarmcares.com">info@wallabieswarmcares.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
